var map = {
	"./nage-no-kata/Harai-goshi.mp4": 9666,
	"./nage-no-kata/Kata-guruma.mp4": 8097,
	"./nage-no-kata/Okuri-ashi-harai.mp4": 6248,
	"./nage-no-kata/Sasae-tsurikomi-ashi.mp4": 583,
	"./nage-no-kata/Seoi-nage.mp4": 6112,
	"./nage-no-kata/Sumi-gaeshi.mp4": 3000,
	"./nage-no-kata/Tomoe-nage.mp4": 50,
	"./nage-no-kata/Tsurikomi-goshi.mp4": 5770,
	"./nage-no-kata/Uchi-mata.mp4": 11,
	"./nage-no-kata/Uki-goshi.mp4": 3848,
	"./nage-no-kata/Uki-otoshi.mp4": 9348,
	"./nage-no-kata/Uki-waza.mp4": 1425,
	"./nage-no-kata/Ura-nage.mp4": 2592,
	"./nage-no-kata/Yoko-gake.mp4": 4853,
	"./nage-no-kata/Yoko-guruma.mp4": 1036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5939;